import React, { useState, useEffect } from "react";
import { getDataWithTypeForSelect } from "../../../lib/parameters";
import { getIdData } from "../../../lib/studentinfo";
import { updateData } from "../../../lib/profiles";
import { useNavigate, useParams } from "react-router-dom";
import { ClassForLessonSelect, SchoolSelect } from "../../ui/myselect";

export default function AdminAddStudentStep2() {
  const [classforLesson, setClassForLesson] = useState(9);
  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const [isActive, setIsActive] = useState();
  const [phone, setPhone] = useState();
  const [username, setUserName] = useState();
  const navigate = useNavigate();
  let { slug, type } = useParams();
  const [school, setSchool] = useState();
  const [graduate, setGraduate] = useState();
  const [gpa, setGpa] = useState();
  const [sat, setSat] = useState();
  const [stateTest, setStateTest] = useState();
  const [major, setMajor] = useState();
  const [career, setCareer] = useState();
  const [fiveAdjectives, setFiveAdjectives] = useState();
  const [hsSchoolStatistics, setHsSchoolStatistics] = useState();
  const [topThreeColleges, setTopThreeColleges] = useState();
  const [lor, setLor] = useState();
  const [activities, setActivities] = useState();
  const [collegeEssay, setCollegeEssay] = useState();
  const [instructorNote, setInstructorNote] = useState();
  const [studentNote, setStudentNote] = useState();
  const [meetLink, setMeetLink] = useState("");
  const [folderLink, setFolderLink] = useState("");
  const [congawardlink, setCongawardLink] = useState("");
  const [satlink , setSatlink] = useState("");
  const [awardlink  , setAwardlink ] = useState("");
  const [calendarlink  , setCalendarlink  ] = useState("");
  const [courselink  , setCourselink   ] = useState("");
  const [visitlink  , setVisitlink    ] = useState("");
  const [deadlinelink  , setDeadlinelink] = useState("");
  const [finaidlink  , setFinaidlink] = useState("");
  const [mainessaylink  , setMainessaylink] = useState("");
  const [supplementallink  , setSupplementallink] = useState("");

  const [studentInfo, setStudentInfo] = useState();

  const statusOptions = [
    { value: true, label: "Active" },
    { value: false, label: "Passive" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    //console.log("school",school);

    await updateData({
      id: slug,
      username: username,
      isActive: isActive,
      name: name,
      surname: surname,
      phone: phone,
      class: classforLesson,
      studentschooltext: school,
      graduateyear: graduate,
      gpa: gpa,
      satpsat: sat,
      statetest: stateTest,
      major: major,
      career: career,
      fiveAdjectives: fiveAdjectives,
      hsSchoolStatistics: hsSchoolStatistics,
      topThreeColleges: topThreeColleges,
      lor: lor,
      activities: activities,
      collegeEssay: collegeEssay,
      instructorNote: instructorNote,
      studentNote: studentNote,
      meetlink: meetLink,
      folderlink: folderLink,
      congawardlink: congawardlink,
      satlink: satlink,
      awardlink: awardlink,
      calendarlink: calendarlink,
      courselink: courselink,
      visitlink: visitlink,
      deadlinelink: deadlinelink,
      finaidlink: finaidlink,
      mainessaylink: mainessaylink,
      supplementallink: supplementallink,
    });
    navigate(-1);
    //navigate(`/admin/admin-studentdetail/${slug}`);
    // navigate(`/admin/admin-studentstep3/${slug}`);
  };

  async function GetData() {
    const info = await getIdData(slug);
    console.log("info", info);
    setStudentInfo(info);
    setName(info[0].name);
    setSurname(info[0].surname);
    setIsActive(info[0].isActive);
    setPhone(info[0].phone);
    setClassForLesson(info[0].class);
    setSchool(info[0].schoolname);
    setUserName(info[0].username);
    setGraduate(info[0].graduateyear);
    setGpa(info[0].gpa);
    setSat(info[0].satpsat);
    setStateTest(info[0].statetest);
    setMajor(info[0].major);
    setCareer(info[0].career);
    setFiveAdjectives(info[0].fiveAdjectives);
    setHsSchoolStatistics(info[0].hsSchoolStatistics);
    setTopThreeColleges(info[0].topThreeColleges);
    setLor(info[0].lor);
    setActivities(info[0].activities);
    setCollegeEssay(info[0].collegeEssay);
    setInstructorNote(info[0].instructorNote);
    setStudentNote(info[0].studentNote);
    setMeetLink(info[0].meetlink);
    setFolderLink(info[0].folderlink);
    setCongawardLink(info[0].congawardlink);
    setSatlink(info[0].satlink);
    setAwardlink(info[0].awardlink);
    setCalendarlink(info[0].calendarlink);
    setCourselink(info[0].courselink);
    setVisitlink(info[0].visitlink);
    setDeadlinelink(info[0].deadlinelink);
    setFinaidlink(info[0].finaidlink);
    setMainessaylink(info[0].mainessaylink);
    setSupplementallink(info[0].supplementallink);
  }

  useEffect(() => {
    console.log("user", slug, type);

    if (type === "Update") GetData();
  }, []);

  return (
    <div className="col-xl-12 col-md-12">
      <div className="settings-widget profile-details">
        <div className="settings-menu p-2">
          <div className="profile-heading p-2">
            <h3>{type === "Add" ? "Add Student" : "Update your profile"}</h3>
          </div>
          <div className="checkout-form personal-address add-course-info ">
            <form role="form" onSubmit={handleSubmit}>
              <div className="row mx-auto">
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className="form-control"
                      placeholder="Enter Name"
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Last Name</label>
                    <input
                      type="text"
                      value={surname}
                      onChange={(e) => setSurname(e.target.value)}
                      className="form-control"
                      placeholder="Enter Last Name"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Status</label>
                    <select
                      id="isActive"
                      value={isActive}
                      onChange={(e) => setIsActive(e.target.value)}
                      className="form-control"
                    >
                      {statusOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Nick Name</label>
                    <input
                      name="text"
                      value={username}
                      onChange={(e) => setUserName(e.target.value)}
                      className="form-control"
                      placeholder="Enter Nick Name"
                    />
                  </div>
                </div>
                {/*}
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Grade Level</label>
                    <input
                      type="number"
                      value={classforLesson}
                      onChange={(e) => setClassForLesson(e.target.value)}
                      className="form-control"
                      placeholder="Enter Level"
                    />
                  </div>
                </div>
{*/}
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Grade Level</label>
                    <ClassForLessonSelect
                      value={classforLesson}
                      setValue={setClassForLesson}
                      name={"ClassForLessonSelect"}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      Five Adjectives:five character trait adjectives that
                      describe you the most
                    </label>
                    <input
                      type="text"
                      value={fiveAdjectives}
                      onChange={(e) => setFiveAdjectives(e.target.value)}
                      className="form-control"
                      placeholder="Enter Five Adjectives:five character trait adjectives that
                      describe you the most"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      About my high school
                    </label>
                    <input
                      type="text"
                      value={hsSchoolStatistics}
                      onChange={(e) => setHsSchoolStatistics(e.target.value)}
                      className="form-control"
                      placeholder="About my high school"
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Phone</label>
                    <input
                      name="phone"
                      placeholder="123-456-7890"
                      pattern="(\d{3}[- ]?\d{3}[- ]?\d{4})"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">School</label>
                    <input
                      type="text"
                      value={school}
                      onChange={(e) => setSchool(e.target.value)}
                      className="form-control"
                      placeholder="My School"
                    />
                  </div>
                </div>
                {/*}
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Class</label>
                    <ClassForLessonSelect
                      value={classforLesson}
                      setValue={setClassForLesson}
                      name={"ClassForLessonSelect"}
                    />
                  </div>
                </div>
{*/}
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      Graduation year
                    </label>
                    <input
                      name="text"
                      value={graduate}
                      onChange={(e) => setGraduate(e.target.value)}
                      className="form-control"
                      placeholder="Enter Graduation year"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      GPA: Weighted and unweighted GPA if known
                    </label>
                    <input
                      name="text"
                      value={gpa}
                      onChange={(e) => setGpa(e.target.value)}
                      className="form-control"
                      placeholder="Enter GPA: Weighted and unweighted GPA if known"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      SAT and or PSAT scores and the date of testing
                    </label>
                    <textarea
                      name="text"
                      value={sat}
                      onChange={(e) => setSat(e.target.value)}
                      className="form-control"
                      placeholder="Enter SAT and or PSAT scores and the date of testing"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      Practice SAT: Official practice SAT score and the date of
                      testing
                    </label>
                    <textarea
                      name="text"
                      value={stateTest}
                      onChange={(e) => setStateTest(e.target.value)}
                      className="form-control"
                      placeholder="Enter Practice SAT: Official practice SAT score and the date of
                      testing"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      Major: What do you want to study in college?
                    </label>
                    <input
                      name="text"
                      value={major}
                      onChange={(e) => setMajor(e.target.value)}
                      className="form-control"
                      placeholder="Enter Major: What do you want to study in college?"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      Career: What do you want to do after college?
                    </label>
                    <input
                      name="text"
                      value={career}
                      onChange={(e) => setCareer(e.target.value)}
                      className="form-control"
                      placeholder="Enter Career: What do you want to do after college?"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      Desired Colleges Top three college choices
                    </label>
                    <input
                      name="text"
                      value={topThreeColleges}
                      onChange={(e) => setTopThreeColleges(e.target.value)}
                      className="form-control"
                      placeholder="Enter Desired Colleges Top three college choices"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      Letter of Recommendation: Did you get one? It so, which
                      teacher wrote it?
                    </label>
                    <input
                      name="text"
                      value={lor}
                      onChange={(e) => setLor(e.target.value)}
                      className="form-control"
                      placeholder="Enter Letter of Recommendation: Did you get one? It so, which
                      teacher wrote it?"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      Activities: List all activities outside of your high
                      school hours
                    </label>
                    <input
                      name="text"
                      value={activities}
                      onChange={(e) => setActivities(e.target.value)}
                      className="form-control"
                      placeholder="Enter Activities: List all activities outside of your high
                      school hours"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      College Essay: What progress have you made on your essay
                      so far?
                    </label>
                    <input
                      name="text"
                      value={collegeEssay}
                      onChange={(e) => setCollegeEssay(e.target.value)}
                      className="form-control"
                      placeholder="Enter College Essay: What progress have you made on your essay
                      so far?"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      Counselor&apos;s Comment
                    </label>
                    <input
                      name="text"
                      value={instructorNote}
                      onChange={(e) => setInstructorNote(e.target.value)}
                      className="form-control"
                      placeholder="Enter Counselor's Comment"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">
                      Student&apos;s Comment
                    </label>
                    <input
                      name="text"
                      value={studentNote}
                      onChange={(e) => setStudentNote(e.target.value)}
                      className="form-control"
                      placeholder="Enter  Student's Comment"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Zoom Link</label>
                    <input
                      name="text"
                      value={meetLink}
                      onChange={(e) => setMeetLink(e.target.value)}
                      className="form-control"
                      placeholder="Enter Zoom Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Folder Link</label>
                    <input
                      name="text"
                      value={folderLink}
                      onChange={(e) => setFolderLink(e.target.value)}
                      className="form-control"
                      placeholder="Enter Folder Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Congressional Award Link</label>
                    <input
                      name="text"
                      value={congawardlink}
                      onChange={(e) => setCongawardLink(e.target.value)}
                      className="form-control"
                      placeholder="Enter Congressional Award Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">SAT Link</label>
                    <input
                      name="text"
                      value={satlink}
                      onChange={(e) => setSatlink(e.target.value)}
                      className="form-control"
                      placeholder="Enter SAT Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Awards Link</label>
                    <input
                      name="text"
                      value={awardlink}
                      onChange={(e) => setAwardlink(e.target.value)}
                      className="form-control"
                      placeholder="Enter Awards Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Calendar Link</label>
                    <input
                      name="text"
                      value={calendarlink}
                      onChange={(e) => setCalendarlink(e.target.value)}
                      className="form-control"
                      placeholder="Enter Calendar Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">College Courses Link</label>
                    <input
                      name="text"
                      value={courselink}
                      onChange={(e) => setCourselink(e.target.value)}
                      className="form-control"
                      placeholder="Enter College Courses Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">College Visits Link</label>
                    <input
                      name="text"
                      value={visitlink}
                      onChange={(e) => setVisitlink(e.target.value)}
                      className="form-control"
                      placeholder="Enter College Visits Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">DeadLine Link</label>
                    <input
                      name="text"
                      value={deadlinelink}
                      onChange={(e) => setDeadlinelink(e.target.value)}
                      className="form-control"
                      placeholder="Enter DeadLine Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Fin. Aid Link</label>
                    <input
                      name="text"
                      value={finaidlink}
                      onChange={(e) => setFinaidlink(e.target.value)}
                      className="form-control"
                      placeholder="Enter Fin. Aid Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Main Essay Link</label>
                    <input
                      name="text"
                      value={mainessaylink}
                      onChange={(e) => setMainessaylink(e.target.value)}
                      className="form-control"
                      placeholder="Enter Main Essay Link"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-control-label">Supplementals Link</label>
                    <input
                      name="text"
                      value={supplementallink}
                      onChange={(e) => setSupplementallink(e.target.value)}
                      className="form-control"
                      placeholder="EnterSupplementals Link"
                    />
                  </div>
                </div>
                <div className="update-profile d-flex flex-column gap-3 flex-sm-row justify-content-between">
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                  <button
                    onClick={() =>
                      navigate(`/admin/admin-studentdetail/${slug}`)
                    }
                    className="btn btn-black btn-sm update_page_cancel_btn"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

{
  /* <div className="update-profile d-flex justify-content-between">
<button type="submit" className="btn btn-primary">
  {type === "Add" ? "Next Step >>" : "Update"}
</button>
<button
  onClick={() => navigate(-1)}
  className="btn btn-black btn-sm"
>
  Cancel
</button>
</div> */
}
